import { useContext } from 'react';
import { DataResourceContext } from '../components/data/dataResourceContext';
import { ContentData } from '@nucleus/types/web';

export const usePageContent = (area: string): Array<ContentData> => {
  const { page } = useContext(DataResourceContext);

  return page?.content[area] ?? [];
};
